
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { getSupabase } from '../firebase';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private zone: NgZone) {}

  handleError(error: any): void {
    // Log to console for dev debugging
    console.error('🔥 Global Error Handler Caught:', error);

    // Extract useful info
    const message = error.message || error.toString();
    const stack = error.stack || 'No stack trace';
    const url = window.location.href;

    // Send to Supabase (Fire and forget, don't await)
    this.logErrorToSupabase(message, stack, url);
  }

  private async logErrorToSupabase(message: string, stack: string, url: string) {
    const supabase = getSupabase();
    if (!supabase) return;

    try {
        // Use the RPC we just created
        await supabase.rpc('log_client_error', {
            p_message: message,
            p_stack: stack,
            p_url: url,
            p_metadata: {
                timestamp: new Date().toISOString(),
                platform: navigator.platform
            }
        });
    } catch (e) {
        console.warn('Failed to send error log to server:', e);
    }
  }
}
